import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { SequentialLinkLists } from "./SequentialLinkLists";
import { SingleLinkList } from "./SingleLinkList";
import { TabbedLinkLists } from "./TabbedLinkLists";
export var LinkLists = function(props) {
    var badge = props.badge, heading = props.heading, lists = props.lists, rules = props.rules, translations = props.translations;
    var renderSequentially = (rules || {}).renderSequentially;
    if (renderSequentially) {
        return /*#__PURE__*/ _jsx(SequentialLinkLists, {
            lists: lists,
            translations: translations
        });
    }
    if (lists.length === 1) {
        return /*#__PURE__*/ _jsx(SingleLinkList, {
            badge: badge,
            heading: heading,
            list: lists[0],
            translations: translations
        });
    }
    return /*#__PURE__*/ _jsx(TabbedLinkLists, {
        lists: lists
    });
};
